import { useL10n } from "@ews/react-localization-context";
import { FC } from "react";
import
{
    Navbar,
    NavbarLink
} from "./Navbar";


import Icon from "@ews/react-icons";
import { iif } from "../../../utils";
import { useNamedRoutes } from "../../NamedRoutes";
import { useIsMobile } from "../../Responsive";
import { MenuToggleProps } from "../types";

const Main: FC<MenuToggleProps> = ({ onMenuToggle }) =>
{
    const { translate: t } = useL10n();
    const { generate } = useNamedRoutes();
    const isMobile = useIsMobile();

    const color = isMobile ? 'primary' : 'light';

    return (
        <Navbar
            onMenuToggle={onMenuToggle}
            color={color}
        >
            <NavbarLink show={!isMobile}
                icon={<img style={{ maxHeight: "100%", padding: "5px" }} alt="logo" src='assets/img/App-Icon-ReACT_invert.png' />}
                link={generate('home')}
            />
            <NavbarLink
                icon={iif(isMobile, <Icon icon={"clients"} />)}
                title={t('COM_FACPMANAGEMENT_FACP_MANAGER_CUSTOMERS') as any}
                link={generate('customers')}
            />
            <NavbarLink
                icon={iif(isMobile, <Icon icon={"bmz_body"} />)}
                title={t('COM_FACPMANAGEMENT_FACP_MANAGER_FIREALARMPANELS') as any}
                link={generate('systems')}
            />
            <NavbarLink
                icon={iif(isMobile, <Icon icon={"user"} />)}
                title={t('TD_USERNAME') as any}
                link={generate('users')}
            />
        </Navbar>
    );

};

export default Main;
